<template>
  <b-modal :active="show" @close="toggle" class="modal" has-modal-card>
    <div class="modal-content">
      <h2 class="title">Invite colleagues to Truckl</h2>
      <div class="content">
        <p class="contenet">
          Enter the email address of others from your company who you wish to invite to use Truckl. You can always do this at a later time as well.
          If you need to send a large number of invitations, simply create a list of emails separated by a comma (,) and paste it in to any field on this screen.
        </p>

        <invite-to-company v-model="emailList" />
      </div>
      <div class="columns">
        <div class="column">
          <button type="button"
                  @click="sendInvites"
                  :disabled="isLoading"
                  :class="{ 'is-loading': isLoading }"
                  class="button is-primary is-fullwidth">
            Send Invitations
          </button>
        </div>

        <div class="column is-one-third">
          <button type="button"
                  @click="toggle"
                  :disabled="isLoading"
                  class="button is-fullwidth">
            Close
          </button>
        </div>
      </div>
    </div>

  </b-modal>
</template>

<script>
import InviteToCompany from '@/components/InviteToCompany'
import InviteApi from '@/api-interface/invite'
import { mapState } from 'vuex'

export default {
  name: 'InviteToCompanyModal',

  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  computed: {
    ...mapState('company', ['currentCompanyInfo'])
  },

  data() {
    return {
      isLoading: false,
      emailList: []
    }
  },

  components: {
    InviteToCompany
  },

  methods: {
    toggle() {
      this.$emit('update:show', false)
    },

    async sendInvites() {
      const cleanList = Array.from(new Set(this.emailList))

      try {
        this.isLoading = true
        await InviteApi.inviteToCompanyBulk({ companyKey: this.currentCompanyInfo.companyKey, emailList: cleanList })
      } catch (error) {
        console.error('Error sending company invite.', error)
      } finally {
        this.isLoading = false
        this.toggle()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.modal-content {
  background-color: white;
  border-radius: 10px;
  padding: 15px;
  width: 750px;
}

.content {
  // width: 700px;
}
</style>
